// extracted by mini-css-extract-plugin
export default {"wrapper":"menu_wrapper__7y4FA","active":"menu_active__m2wgY","icon":"menu_icon__sm954","links":"menu_links__-vrgS","profile":"menu_profile__a9wNc"};